/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

        // Breakpoint
        window.bp = new Breakpoint();

        window.cache = {
          $window: $(window),
          $document: $(document),
          $body: $('body'),
        };


        // Set a cookie with a specified value and expiration
        window.setCookie = function setCookie(name, value, days) {
          var expires = "";
          if (days) {
              var date = new Date();
              date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
              expires = "; expires=" + date.toUTCString();
          }
          document.cookie = name + "=" + value + expires + "; path=/";
        }

        // Retrieve the value of the cookie
        window.getCookie = function getCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') c = c.substring(1, c.length);
              if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
          }
          return null;
        }

        // Modernizr example
        if (!Modernizr.touchevents) {
          console.log('notouch');
        } else {
          console.log('touch');
        }

        // Custom Select
        $('.js-select2').each(function(){
          console.log('select initiated');
          
          var placeholder = $(this).attr('placeholder');

          $(this).select2({
            minimumResultsForSearch: -1,
            placeholder: placeholder,
          });
        });

        // Custom File Upload
        var $fileUploads = $('.js-fileupload');

        for (var i = 0, length = $fileUploads.length; i < length; i++) {
            new FileUpload({
                $el: $($fileUploads[i])
            });
        }

        //---------
        // Header
        //---------
        var $header = $('[data-module="header"]');
        if ($header.length > 0) {
          new Header({
            $el: $header
          });
        }

        //---------
        // Footer
        //---------
        var $footer = $('footer');
        // Open pdf links in a new tab
        $footer.find('.footer__links a').each(function(){
          if( $(this).attr('href').indexOf('.pdf') > 0 ){
            $(this).attr('target', '_blank');
          }
        })
        
        //---------
        // Map Location
        //---------
        var $mapPage = $('[data-module="mapLocation"]');
        if ($mapPage.length > 0) {
          window.mapLocationInstance = new MapLocation({
            $el: $mapPage
          });
        }

        //---------
        // Init components
        //---------
        var $components = $("[data-component]");
        $components.each(function(index){
          var $el = $(this);
          var comp = $el.data('component');
          
          //Check if component exist
          if(typeof window.Components[comp] !== 'function') { 
            return;
          }
          
          // Component instantiation
          var obj = new window.Components[comp]($el);
          // Store instance in data
          $el.data('comp', obj);
        });

        // Contest Form Validate
        // $('.js-contest-form').validate();

        //---------
        // Filter
        //---------
        var $filter = $('[data-module="filter"]');
        if ($filter.length > 0) {
          new Filter({
            $el: $filter
          });
        }

        //---------
        // Popup
        //---------
        var $popup = $('[data-module="popup"]');
        if ($popup.length > 0) {
          new Popup({
            $el: $popup
          });
        }


        //---------
        // Popup Mailchimp
        //---------
        var $popupMc = $('[data-module="popup-mc"]');
        if ($popupMc.length > 0) {
          new PopupMc({
            $el: $popupMc
          });
        }


        //---------
        // Activate link on division
        //---------
        $('.js-block-link').on('click', function(e) {
          e.preventDefault();

          window.location = $(this).find('a').attr('href');
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
